import { forwardRef} from 'react';
import { BaseMUIComponentProps } from './types/Types';


export const BaseMUIComponent = forwardRef<HTMLDivElement, BaseMUIComponentProps>(
  ({ children, className, ...props }, ref) => {
    return (
      <div ref={ref} {...props}>
        {children}
      </div>
    );
  }
);